import filtersDisplayConfig from "./filtersDisplay.config";
import apiPathsConfig from './apiPaths.config';
import LiveStreamsTableListItem from "../LiveStreamsListItem/LiveStreamsTableListItem.vue"
import availableActionsConfig from "./availableActions.config";
import availableListViewsConfig from "./availableListViews.config";
import listNamesConfig from "./listNames.config";
import { columns } from "./columns.config"

const itemsListerConfig = {
  TableViewItem: LiveStreamsTableListItem,
  apiPathsConfig,
  filtersDisplayConfig,
  isAddAllFiltersConfig: true,
  columns,
  availableActionsConfig,
  availableListViewsConfig,
  ...listNamesConfig
}

export default itemsListerConfig;